export default __webpack_public_path__ + "static/media/b-11.ea274e38.png";